import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { TerminateStakeholderDto } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useTerminate = () => {
  const { mutate: terminate, isPending } = useAppMutation([QueryKey.TERMINATE_STAKEHOLDERS], {
    mutationFn: ({ companyId, data }: { companyId: string; data: TerminateStakeholderDto }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'stakeholders', 'terminate'] },
        { body: data },
      ),
  });
  return { terminate, isPending };
};
